import { Serializable } from "@/core/api/decorators/serializable_decorator"
import {
  PriceCategoryBaseModel,
  PriceCategoryBaseData,
} from "./priceCategoryBaseModel"
import { PriceType } from "../../constants/priceType"
import { IsNumber } from "class-validator"

@Serializable
export class PriceCategoryFreeModel extends PriceCategoryBaseModel {
  priceType: PriceType.Free = 2
  @IsNumber(
    { allowNaN: false, allowInfinity: false, maxDecimalPlaces: 0 },
    {
      message: "form.errors.empty",
      groups: ["price_table"],
    },
  )
  amount: number = 0

  constructor(
    data:
      | (Omit<PriceCategoryBaseData, "priceType"> & {
          priceType: PriceType.Free
          amount?: number
          numConsultants?: number
          hourlyRateOverwrite?: number
        })
      | null = null,
  ) {
    super(data)
    if (data) {
      this.amount = data.amount ?? 0
    }
  }
}
